window.addEventListener('load', function() {

  // Get Modal
  var popup_movie = document.querySelector('#popup_movie');
  if( ! popup_movie )
    return;

  // Continue only if not displayed yet
  if( localStorage.getItem('alreadyAlertedForMovie') == "true" )
    return;

  // Get stored timer orset to 0
  var timer = localStorage.getItem('timer');
  if ( ! timer )
    timer = 0;

  // Create an interval each second
  var interval = setInterval(function () {

    // Increase & store timer
    timer++;
    localStorage.setItem('timer', timer);

    // After 1' of navigation..
    if (timer >= 1) {

      // Launch modal
      document.querySelector('#popup_movie_trigger').click();

      // Prevent relaunching Modal
      localStorage.setItem('alreadyAlertedForMovie', "true");

      // Stop interval
      clearInterval(interval);

    }
  }, 1000); // Each second

});
